import { Stack, Typography } from "@mui/material";
import { type FC } from "react";

import { PlatformIcon } from "~/components/UI/PlatformIcons/PlatformIcons.styles";

const MARKET_ICON_SIZE = 20;

interface IAverageCellProps {
  outcomeTitle?: string | null;
}

export const AverageCell: FC<IAverageCellProps> = ({ outcomeTitle }) => {
  return (
    <Stack
      direction="row"
      sx={{
        alignItems: "center",
        height: "100%",
        width: "100%",
        gap: 1,
      }}
    >
      <PlatformIcon
        src="/android-icon-96x96.png"
        alt="PredictionHero"
        size={MARKET_ICON_SIZE}
        isFirst
      />
      <Typography
        variant="caption"
        sx={{
          fontWeight: 700,
        }}
      >
        PH Consensus{outcomeTitle && ` · ${outcomeTitle}`}
      </Typography>
    </Stack>
  );
};
